import { render } from "./PaymentStatus.vue?vue&type=template&id=3124bd9e&scoped=true&ts=true"
import script from "./PaymentStatus.vue?vue&type=script&lang=ts"
export * from "./PaymentStatus.vue?vue&type=script&lang=ts"

import "./PaymentStatus.vue?vue&type=style&index=0&id=3124bd9e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3124bd9e"]])

export default __exports__